import { useEffect } from 'react';

// ID MISURAZIONE AGGIORNATO (Dallo stream creato poco fa)
const GA_MEASUREMENT_ID = 'G-31Y88JGHCG';

function GoogleAnalytics() {
  useEffect(() => {
    // Inizializza Google Consent Mode v2 (default: denied)
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    // Imposta il consent mode di default (GDPR compliant)
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });

    // Carica il tag Google
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Aggiorna il consent in base alle preferenze
    const updateConsent = (preferences) => {
      if (!window.gtag) return;

      gtag('consent', 'update', {
        'analytics_storage': preferences.analytics ? 'granted' : 'denied',
        'ad_storage': preferences.marketing ? 'granted' : 'denied',
        'ad_user_data': preferences.marketing ? 'granted' : 'denied',
        'ad_personalization': preferences.marketing ? 'granted' : 'denied'
      });

      if (preferences.analytics) {
        // Forza l'invio della page_view dopo il consenso
        gtag('config', GA_MEASUREMENT_ID, {
          'update': true,
          'anonymize_ip': true
        });

        gtag('event', 'cookie_consent_granted', {
          'event_category': 'engagement',
          'event_label': 'Analytics accepted'
        });
      }
    };

    script.onload = () => {
      gtag('js', new Date());
      gtag('config', GA_MEASUREMENT_ID, {
        'anonymize_ip': true
      });

      // Controlla se esiste già un consenso nel localStorage
      const consent = localStorage.getItem('cookieConsent');
      if (consent) {
        try {
          const { preferences } = JSON.parse(consent);
          updateConsent(preferences);
        } catch (e) {
          console.error("Errore parse consent:", e);
        }
      }
    };

    // Listener per i cambiamenti di localStorage (se l'utente aggiorna dal banner)
    const handleStorageChange = (e) => {
      if (e.key === 'cookieConsent' && e.newValue) {
        const { preferences } = JSON.parse(e.newValue);
        updateConsent(preferences);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.updateGAConsent = updateConsent;

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return null;
}

export default GoogleAnalytics;